import SummaryCard from "./SummaryCardContainer";

export default SummaryCard;
